
(() => {
  const init=(root)=>{
    if(!root||root.dataset.ready==='true')return;root.dataset.ready='true';
    root.querySelectorAll('[data-jtlm-faq-button]').forEach((button)=>{
      button.addEventListener('click',()=>{
        const answer=button.parentElement?.querySelector('[data-jtlm-faq-answer]');if(!answer)return;
        const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));answer.hidden=expanded;
        const icon=button.querySelector('[data-jtlm-faq-icon]');if(icon)icon.textContent=expanded?'+':'−';
      });
    });
  };
  const initAll=()=>document.querySelectorAll('[data-jtlm-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
